import React, { Component } from 'react';


function formatSeatList(seats) {
    if (!seats || seats.length === 0) return '';
    return seats.map((seat) => `Player ${seat + 1}`).join(', ');
}


export class GhostWaveEventComponent extends Component {

    render() {
        const data = this.props.receivedMessage.package.data;
        const tierOneCount = data.tier_one_count;
        const tierTwoCount = data.tier_two_count;
        const tierOneSeats = data.tier_one_seats || [];
        const tierTwoSeats = data.tier_two_seats || [];
        const yourTier = data.tier;
        const showTierOne = tierOneSeats.length > 0
            && tierOneCount !== undefined;
        const showTierTwo = tierTwoSeats.length > 0
            && tierTwoCount !== undefined;
        if (!showTierOne && !showTierTwo) {
            return <></>;
        }
        return <div className={'ghost-wave-event'}>
            {showTierOne && <div className={'ghost-wave-tier'}>
                First Fate Level (1-10 Snohe): rolled {tierOneCount}
                {' '}-- affects {formatSeatList(tierOneSeats)}.
            </div>}
            {showTierTwo && <div className={'ghost-wave-tier'}>
                Second Fate Level (11+ Snohe): rolled {tierTwoCount}
                {' '}-- affects {formatSeatList(tierTwoSeats)}.
            </div>}
            {yourTier && <div className={'ghost-wave-own-tier'}>
                You were affected by {yourTier === 1
                    ? 'First Fate Level'
                    : 'Second Fate Level'}.
            </div>}
        </div>;
    }
}
